/* magnora-cart.js
   Add-to-cart para las cards de Magnora.
   Usa el mismo patron que cart.js nativo de Craft:
   POST /cart/add.js con sections= para recibir el HTML
   del drawer actualizado en una sola request.
*/
(function () {
  'use strict';

  /* --- helpers de estado del boton --- */
  function setState(btn, state) {
    btn.querySelector('.mgn-btn__text').style.display    = state === 'idle'    ? '' : 'none';
    btn.querySelector('.mgn-btn__loading').style.display = state === 'loading' ? '' : 'none';
    btn.querySelector('.mgn-btn__done').style.display    = state === 'done'    ? '' : 'none';
    btn.disabled = (state !== 'idle');
  }

  /* --- abre el drawer exactamente como lo hace el tema nativo --- */
  function openDrawer(sectionsHTML) {
    var drawerEl = document.getElementById('CartDrawer');
    if (!drawerEl) return;

    var cartDrawer = drawerEl.closest('cart-drawer') || document.querySelector('cart-drawer');
    if (!cartDrawer) return;

    /* renderContents espera un objeto con { sections: { 'cart-drawer': html, 'cart-icon-bubble': html } } */
    if (sectionsHTML && cartDrawer.renderContents) {
      cartDrawer.renderContents({ sections: sectionsHTML });
    } else {
      /* fallback: abrir sin re-render */
      cartDrawer.open && cartDrawer.open();
    }
  }

  /* --- handler principal --- */
  function addToCart(btn) {
    var variantId  = parseInt(btn.getAttribute('data-variant-id'), 10);
    var productUrl = btn.getAttribute('data-product-url') || '';
    if (!variantId) return;

    setState(btn, 'loading');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      /* sections le dice a Shopify que devuelva el HTML
         del drawer y del bubble ya actualizado */
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
        sections: ['cart-drawer', 'cart-icon-bubble'],
        sections_url: window.location.pathname
      })
    })
    .then(function (res) {
      if (!res.ok) throw new Error('add_failed');
      return res.json();
    })
    .then(function (data) {
      setState(btn, 'done');

      /* data.sections contiene el HTML listo para inyectar */
      openDrawer(data.sections || null);

      /* volver a idle despues de 2s */
      setTimeout(function () { setState(btn, 'idle'); }, 2000);
    })
    .catch(function (err) {
      console.warn('Magnora cart error:', err);
      setState(btn, 'idle');
      /* fallback: ir a la pagina del producto */
      if (productUrl) window.location.href = productUrl;
    });
  }

  /* --- delegacion de eventos --- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.mgn-btn--cart');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    addToCart(btn);
  });

}());
